export interface AirbnbReservationAlterationBase {
  external_id: string
  status: string //  "PENDING",
  initiated_by: 'host' | 'guest' //  "host",
  start_date: string //  "2021-08-02",
  end_date: string //  "2021-08-04",
  nights: number // 2,
  guest_details: {
    number_of_adults: number // 2,
    number_of_children: number // 0,
    number_of_infants: number // 0,
    number_of_pets: number // 0
  }
}

export interface AirbnbReservationAlterationItem extends AirbnbReservationAlterationBase {
  canceled: number // 0,
  rental_id: string // "01977a5f-dddc-7eda-a4a8-ac8485dceca3-tk2",
  updated: number // 1758539354,
  external_room_id: number // 908402154437679900,
  inquiry_source: string // "airbnb",
  pkey: string // "0199711d-11f2-70d2-873a-2361c56ef04e-tk2",
  inquiry_id: string // "HMWYADZDZA",
  created: number // 1758539354,
  account: number // 1738049422.7923,
  propertyId: number // 470353321
}

export interface AirbnbReservationAlterationPriceQuoteResponse extends AirbnbReservationAlterationBase {
  confirmation_code: string //  "HM3Z4M4T2S",
  listing_id: string //  "42605677",
  expected_payout_amount_accurate: number // "86.00",
  listing_base_price_accurate: number // "100.00",
  listing_cleaning_fee_accurate: number // "0.00",
  listing_cancellation_payout_accurate: number // "86.00",
  listing_cancellation_host_fee_accurate: number // "14.00",
  standard_fees_details: any[]
  promotion_details: any[]
  pricing_rule_details: any[]
  host_fee_base_accurate: number // "14.00",
  host_fee_vat_accurate: number // "0.00",
  expected_payout_amount_before_taxes_accurate: number // "86.00",
  airbnb_collected_tax_amount_accurate: number // "0.00",
  airbnb_collected_tax_details: any[]
  pass_through_tax_details: any[]
  pass_through_tax_expected_amount_accurate: number // "0.00"
}

export interface AirbnbReservationAlterationResponse extends AirbnbReservationAlterationPriceQuoteResponse {
  id: string // "1425790543393205934",
  initiated_by: 'host' | 'guest' // "host",
  status: string // "PENDING",
  guest_fee_vat_accurate: number // "0.00",
  listing_host_fee_accurate: number // "4.50",
  guest_fee_base_accurate: number // "0.00",
  created_at: string //  "2025-05-21T05:11:17.726Z",
  updated_at: string // "2025-05-21T05:11:17.726Z",
}

export function isPendingAirbnbAlteration(alteration: AirbnbReservationAlterationResponse | null) {
  return /pending/i.test(alteration?.status)
}

export interface AirbnbReservationAlterationPriceQuotePayload {
  listing_id?: string //  "42605677",
  total_price_override?: number //  "100.00",
  start_date: string //  "2023-08-01",
  end_date: string //  "2023-08-02",
  number_of_adults: number //  2,
  number_of_children: number //  1,
  number_of_infants: number //  0,
  number_of_pets?: number //  1
}
